import { gql } from '@apollo/client';
import { BASE_PARTNER_COMPANY_FRAGMENT, BASE_PARTNER_REQUEST_FRAGMENT } from './partner.fragments';

export const QUESTIONNAIRE_QUESTION_OPTION_FRAGMENT = gql`
  fragment questionnaireQuestionOptionValues on QuestionnaireQuestionOption {
    id
    text
    isCommentRequired
  }
`;

export const QUESTIONNAIRE_QUESTION_FRAGMENT = gql`
  fragment questionnaireQuestionValues on QuestionnaireQuestion {
    id
    questionText
    description
    answerText
    questionType
    selectedOptionIds
    isRequired
    commentText
    riskLevel
    options {
      ...questionnaireQuestionOptionValues
    }
    proofDocuments {
      id
      title
      url
    }
  }
  ${QUESTIONNAIRE_QUESTION_OPTION_FRAGMENT}
`;

export const QUESTIONNAIRE_SECTION_FRAGMENT = gql`
  fragment questionnaireSectionValues on QuestionnaireSection {
    id
    title
    description
    questions {
      ...questionnaireQuestionValues
    }
  }
  ${QUESTIONNAIRE_QUESTION_FRAGMENT}
`;

export const QUESTIONNAIRE_TEMPLATE_FRAGMENT = gql`
  fragment questionnaireTemplateValues on QuestionnaireTemplate {
    id
    title
    createdTimestamp
  }
`;

export const BASE_QUESTIONNAIRE_FRAGMENT = gql`
  fragment baseQuestionnaireValues on Questionnaire {
    id
    title
    templateId
    year
    externalId
    createdBy {
      ...basePartnerCompanyValues
    }
  }
  ${BASE_PARTNER_COMPANY_FRAGMENT}
`;

export const QUESTIONNAIRE_FRAGMENT = gql`
  fragment questionnaireValues on Questionnaire {
    ...baseQuestionnaireValues
    sections {
      ...questionnaireSectionValues
    }
    requestsSent {
      ...basePartnerRequestValues
    }
    requestReceived {
      ...basePartnerRequestValues
    }
  }
  ${BASE_QUESTIONNAIRE_FRAGMENT}
  ${BASE_PARTNER_REQUEST_FRAGMENT}
  ${QUESTIONNAIRE_SECTION_FRAGMENT}
`;

export const BASE_QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT = gql`
  fragment baseQuestionnaireCompanyResponseValues on QuestionnaireCompanyResponse {
    id
    questionnaireId
    riskLevel
    modifiedTimestamp
    answerSummary {
      lowRiskCount
      mediumRiskCount
      highRiskCount
    }
    partnerRequest {
      ...basePartnerRequestValues
    }
  }
  ${BASE_PARTNER_REQUEST_FRAGMENT}
`;

export const QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT = gql`
  fragment questionnaireCompanyResponseValues on QuestionnaireCompanyResponse {
    ...baseQuestionnaireCompanyResponseValues
    sections {
      ...questionnaireSectionValues
    }
  }
  ${QUESTIONNAIRE_SECTION_FRAGMENT}
  ${BASE_QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT}
`;
